import React, { useEffect, useRef, useState } from 'react';
import { HomeData, Homevideo } from '../../types/home';
import OptimizedImage from '../about/OptimizedImage';

import fetchAPI from '../../helper/axios';
interface VideoSectionProps {
  data: HomeData | null;
  image: Homevideo | null;
}

const VideoSection: React.FC<VideoSectionProps> = ({ data, image }) => {
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
      const [loading, setLoading] = useState<boolean>(true);
         const [error, setError] = useState<string | null>(null);
     const [retry, setRetry] = useState(0); // for retry trigger
  const handleVideoClick = () => {
    setIsVideoModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsVideoModalOpen(false);
  };
  let videoUrl="";
     if(image?.field_media_oembed_video?.[0]?.value){
       videoUrl = image?.field_media_oembed_video?.[0]?.value.replace("watch?v=", "embed/");
    }
// useEffect(() => {
//     const loadData = async () => {
//       try {

//           // setVideoUrl(await fetchAPI('media/122/edit'));
//     let response: Response;
        
//             response = await fetchAPI('media/122/edit');
        
//          const data = await response.json();

//         setVideoUrl(data.data.attributes.field_media_oembed_video[0].value);
   
//       } catch (err: any) {
//         setError(err.message);
//          setError(err.message);
//            // Retry after 3 seconds
//         setTimeout(() => setRetry((prev) => prev + 1), 3000);
//       } finally {
//         setLoading(false);
//       }
//     };

//     loadData();
//   }, [retry]);
// console.log(data?.status?.[0]?.value);
// console.log(image?.status?.[0]?.value);

  return (
    <>
      <section id="videoplay" className={`section about pt-md-5 ${!image?.status?.[0]?.value ? 'pb-2' : 'pb-sm-0 pb-md-1 pb-lg-2'}  ${ !data?.status?.[0]?.value && !image?.status?.[0]?.value ? 'd-none' : ''}`}>
        <div className="container">
        
            <div
              className={`row gx-2 align-items-xl-start text-center ${
                data?.status?.[0]?.value ? '' : 'd-none'
              }`}
            >
            <div className="offset-xl-1 col-xl-10 content mt-md-4">
              <label className="label-title">{data?.field_description?.[0]?.value}</label>
            </div>
            <div className="offset-xl-2 col-xl-8 mb-3">
              <div className="row gy-4 icon-boxes">
                <div className="col-sm-12">
                  <p dangerouslySetInnerHTML={{ __html: data?.field_content?.[0]?.value || '' }} />
                </div>
              </div>
            </div>
          </div>
        
         <div
              className={` ${
                image?.status?.[0]?.value ? 'row gy-4' : 'd-none'
              }`}
            >
            <div className="col-sm-12">
              <div className="video">
                {image && (
                  // <OptimizedImage 
                  //   src={image?.thumbnail?.[0]?.url} 
                  //   className="img-fluid" 
                  //   alt="Video Thumbnail"
                  //   loading="lazy"
                  // />
                  <div className="videoWrapper">
                      {/* <iframe
                        src={image?.field_media_oembed_video?.[0]?.value}
                        title="Demo Video"
                        allowFullScreen
                        className="video-iframe"
                      /> */}
                       {/* <ReactPlayer    ref={playerRef} url="https://www.youtube.com/watch?v=vZORRVfFknY" controls width="640px" height="360px" />
                    */}

                      {/* <iframe  className="videoFrame"  
                      src={image?.field_media_oembed_video?.[0]?.value.replace("watch?v=", "embed/")}  title="YouTube video player"
                      allow="accelerometer; autoplay=0;rel=0; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                     
                      allowFullScreen
                      ></iframe> */}
                      <iframe
                          className="videoFrame"
                          src={`${videoUrl}?autoplay=0&rel=0&modestbranding=1&playsinline=1`}
                          title="YouTube video player"
                          frameBorder="0"
                          allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        ></iframe>
                    </div>
                  
                )}
                

                {/* <a href="#" onClick={handleVideoClick} role="button" tabIndex={0}>
                  <i className="bi bi-play-fill"></i>
                </a> */}
              </div>
            </div>
          </div>
         
        </div>
      </section>

      {/* Video Modal */}
      {isVideoModalOpen && (
        <div className="video-modal-overlay" onClick={handleCloseModal}>
          <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-button" onClick={handleCloseModal}>
              ×
            </button>
            <div className="video-container">
              <iframe
                src="assets/img/demo.mp4"
                title="Demo Video"
                allowFullScreen
                className="video-iframe"
              />
            </div>
          </div>
        </div>
      )}

      <style>{`
        .video-modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.8);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
        }
        
        .video-modal-content {
          position: relative;
          max-width: 90vw;
          max-height: 90vh;
          background: white;
          border-radius: 8px;
          overflow: hidden;
        }
        
        .close-button {
          position: absolute;
          top: 10px;
          right: 15px;
          background: none;
          border: none;
          font-size: 2rem;
          color: white;
          cursor: pointer;
          z-index: 10000;
        }
        
        .video-container {
          position: relative;
          width: 100%;
          height: 0;
          padding-bottom: 56.25%; /* 16:9 aspect ratio */
        }
        
        .video-iframe {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border: none;
        }
      `}</style>
    </>
  );
};

export default VideoSection;
